@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;

.buttonWrapper {
  @include typography-v2-body-sm;
  @include border-radius-r2;
  display: flex;
  align-items: center;
  border: none;
  background: none;
  cursor: pointer;
  outline: none;
  height: auto;
  gap: 8px;
  margin-top: 6px;
  color: var(--text-default);
  white-space: nowrap;

  &:hover,
  &:focus-visible {
    background-color: var(--surface-hover);
  }

  &.active {
    background-color: var(--surface-active);
  }

  [data-button] {
    border: none;
  }
}

.microsoftLogoWrapper {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
